type GetCharacterHitsViewStateProps = {
  isSearchResultPending: boolean;
  isAuthLoading: boolean;
  isHitsLoading: boolean;
  characterHitsCount?: number;
  searchHitsCount: number;
  selectedTagsCount?: number;
  searchedQuery?: string;
  refetchingRecommendations: boolean;
  hasNoFavoriteLorebooks: boolean;
};

type CharacterHitsViewState = {
  isDataLoading: boolean;
  hasNoResults: boolean;
};

const getCharacterHitsViewState = ({
  isSearchResultPending,
  isAuthLoading,
  isHitsLoading,
  characterHitsCount,
  searchHitsCount,
  selectedTagsCount,
  searchedQuery,
  refetchingRecommendations,
  hasNoFavoriteLorebooks,
}: GetCharacterHitsViewStateProps): CharacterHitsViewState => {
  const isDataLoading =
    isAuthLoading ||
    isSearchResultPending ||
    (isHitsLoading && characterHitsCount === 0 && selectedTagsCount === 0 && (!searchedQuery || searchedQuery === "*")) ||
    characterHitsCount === undefined ||
    refetchingRecommendations;

  const hasNoResults =
    !isDataLoading && !isHitsLoading && ((searchHitsCount === 0 && ((selectedTagsCount ?? 0) > 0 || !!searchedQuery)) || hasNoFavoriteLorebooks);

  return {
    isDataLoading,
    hasNoResults,
  };
};

export default getCharacterHitsViewState;
